import React from 'react';
import {ReactComponent as Success} from '../../../../assets/icon/success.svg';
import {SuccessIconContainer} from './ModalIcon.styled';
import {IModalIconProps} from "./ModalIcon.helper";

export const SuccessIcon: React.FC<IModalIconProps> = ({clickHandler}) => {
  return <SuccessIconContainer onClick={clickHandler}><Success/></SuccessIconContainer>;
};
